module.exports = __webpack_public_path__ + "static/dashboard-632d6bd31f54b7f571792045c5d9615c.png";